import { BrowserRouter } from "react-router";
import Layout from "./layout/layout";
import AppRoutes from "./routes";
import UserContextProvider from "./context/provider/user-context-provider";
import PasswordlessContextProvider from "./context/provider/passwordless-context-provider";
import { PostLoginOnboarding } from "./pages/post-login-onboardning/post-login-onboarding";
import useOnlineStatus from "./hooks/use-is-online";

function App() {
	useOnlineStatus();

	return (
		<>
			<PasswordlessContextProvider>
				<UserContextProvider>
					<PostLoginOnboarding>
						<BrowserRouter>
							<Layout>
								<AppRoutes />
							</Layout>
						</BrowserRouter>
					</PostLoginOnboarding>
				</UserContextProvider>
			</PasswordlessContextProvider>
		</>
	);
}

export default App;
